var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg047Panda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m422.87 450.146c54.572-46.948 89.13-116.511 89.13-194.146 0-141.385-114.615-256-256-256s-256 114.615-256 256c0 77.635 34.558 147.198 89.13 194.146z",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-18.456-1.953-36.456-5.664-53.804l-98.67-98.67-302.343 69.02 70.831 70.831 148.751 78.415 97.965 128.356c54.572-46.95 89.13-116.513 89.13-194.148z",
    fill: "#ffa300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.663 455.611c0-57.072 46.266-103.337 103.337-103.337s103.337 46.266 103.337 103.337v34.659c23.205-10.251 44.608-23.835 63.583-40.167l-37.122-207.052h-259.596l-37.122 207.052c18.975 16.332 40.378 29.916 63.583 40.167z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.337 455.611v34.659c23.205-10.251 44.608-23.835 63.583-40.167l-37.122-207.052h-129.736v109.223c57.043.034 103.275 46.286 103.275 103.337z",
    fill: "#414952"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 351.273c-57.072 0-103.337 46.266-103.337 103.337v35.676c31.605 13.961 66.565 21.714 103.337 21.714s71.732-7.753 103.337-21.713v-35.676c0-57.072-46.265-103.338-103.337-103.338z",
    fill: "#f2f6fc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m359.337 454.61c0-57.051-46.232-103.303-103.275-103.336v160.725c36.749-.009 71.688-7.76 103.275-21.713z",
    fill: "#dce1eb"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 138.715,
    cy: 137.556,
    fill: "#636978",
    r: 48.38
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 373.285,
    cy: 137.556,
    fill: "#414952",
    r: 48.38
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m399.348 216.439c0 64.775-64.179 88.615-143.348 88.615s-143.348-23.841-143.348-88.615c0-64.775 64.179-139.439 143.348-139.439s143.348 74.664 143.348 139.439z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m399.348 216.439c0-64.758-64.146-139.398-143.286-139.438v228.053c79.141-.013 143.286-23.858 143.286-88.615z",
    fill: "#e9edf5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.414,
    cy: 179.949,
    fill: "#707789",
    rx: 42.394,
    ry: 42.394,
    transform: "matrix(.157 -.988 .988 .157 -15.428 341.834)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.799,
    cy: 185.936,
    fill: "#414952",
    rx: 14.953,
    ry: 14.953,
    transform: "matrix(.231 -.973 .973 .231 -24.992 340.244)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.586,
    cy: 179.949,
    fill: "#555a66",
    rx: 42.394,
    ry: 42.394,
    transform: "matrix(.985 -.172 .172 .985 -26.209 57.708)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.201,
    cy: 185.936,
    fill: "#23272b",
    rx: 14.953,
    ry: 14.953,
    transform: "matrix(.973 -.231 .231 .973 -34.615 76.537)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m282.379 222.814c0 11.753-11.81 21.281-26.379 21.281s-26.379-9.528-26.379-21.281 11.81-12.702 26.379-12.702 26.379.949 26.379 12.702z",
    fill: "#414952"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m282.379 222.814c0-11.736-11.777-12.699-26.317-12.702v33.981c14.54-.026 26.317-9.543 26.317-21.279z",
    fill: "#23272b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg047Panda);
export default __webpack_public_path__ + "static/media/047-panda.b5150579bc851cf858537b01f460c506.svg";
export { ForwardRef as ReactComponent };